import { render, staticRenderFns } from "./XiaopaiLayout.vue?vue&type=template&id=3a7c925f&scoped=true&"
import script from "./XiaopaiLayout.vue?vue&type=script&lang=js&"
export * from "./XiaopaiLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c925f",
  null
  
)

export default component.exports